





























































































import { Component, Vue } from "vue-property-decorator";
import { Button, Cell, Dialog, Empty, ImagePreview } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Empty.name]: Empty,
	[Button.name]: Button,
	[Dialog.Component.name]: Dialog.Component
  }
})
export default class FundsOrderDetails extends Vue {
  detailData: any = {};
  voucherList: any = [];
  previewInstance: any = null;
  requestFail = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;
  showCancel:any = false
  future
  lang: any = localStorage.getItem("localLang") || 'zh-CN';
  get bgColor() {
    return this.$store.getters["common/bgColor"]; 
  }

  get getOrderType() {
    
    return this.$route.query.orderType && Number(this.$route.query.orderType);
  }

  get BtnShow() {
    if(this.getOrderType == 5){
      return false
    }else{
      return  this.detailData && this.detailData['order_status'] === 0 && (this.detailData['funds_change_type'] === 2 || this.detailData['funds_change_type'] === 1)
    }
  }

  get bgColorDialog(){
    return this.bgColor !== 'white-theme' ? 'black-theme-dialog' : ''
  }

  get fieldsList() {
    if (this.getOrderType != 5) {
      return [
        {
          field: "funds_no",
          name: this.$t("funds.orderDetail.fieldsText[0]")
        },
        {
          field: "funds_account_type",
          name: this.$t("funds.orderDetail.fieldsText[1]")
        },
        {
          field: "funds_change_type",
          name: this.$t("funds.orderDetail.fieldsText[2]")
        },
        {
          field: "pay_type",
          name: this.$t("funds.orderDetail.fieldsText[3]")
        },
        {
          field: "order_status",
          name: this.$t("funds.orderDetail.fieldsText[4]")
        },
        {
          field: "remittance_currency",
          name:
            this.getOrderType === 1
              ? this.$t("funds.orderDetail.fieldsText[5]")
              : this.getOrderType === 2
              ? this.$t("funds.orderDetail.fieldsText[6]")
              : "",
          gap: true
        },
        {
          field: "amount",
          name:
            this.getOrderType === 1
              ? this.$t("funds.orderDetail.fieldsText[7]")
              : this.getOrderType === 2
              ? this.$t("funds.orderDetail.fieldsText[8]")
              : ""
        },
        {
          field: "created_at",
          name:
            this.getOrderType === 1
              ? this.$t("funds.orderDetail.fieldsText[9]")
              : this.getOrderType === 2
              ? this.$t("funds.orderDetail.fieldsText[10]")
              : ""
        },
        {
          field: "handling_fee",
          name: this.$t("funds.orderDetail.fieldsText[11]")
        },
        {
          field: "received_amount",
          name:
            this.getOrderType === 1
              ? this.$t("funds.orderDetail.fieldsText[12]")
              : this.getOrderType === 2
              ? this.$t("funds.orderDetail.fieldsText[13]")
              : ""
        },
        {
          field: "received_at",
          name: this.$t("funds.orderDetail.fieldsText[14]")
        }
      ];
    } else {
      return [
        {
          field: "funds_no",
          name: this.$t("funds.orderDetail.fieldsText[0]")
        },
        {
          field: "funds_account_type",
          name: this.$t("funds.orderDetail.fieldsText[1]")
        },
        {
          field: "funds_change_type",
          name: this.$t("funds.orderDetail.fieldsText[2]")
        },
        {
          field: "pay_type",
          name: this.$t("funds.orderDetail.fieldsText[3]")
        },
        {
          field: "order_status",
          name: this.$t("funds.orderDetail.fieldsText[4]")
        },
        {
          field: "remittance_currency",
          name: this.$t("funds.orderDetail.otherText[0]"),
          gap: true
        },
        {
          field: "amount",
          name: this.$t("funds.orderDetail.otherText[1]")
        },
        {
          field: "created_at",
          name: this.$t("funds.orderDetail.otherText[2]")
        },
        {
          field: "received_at",
          name: this.$t("funds.orderDetail.fieldsText[14]")
        }
      ];
    }

  }

  created() {
    this.getOrderDetailData();
  }

  /**
   * 格式化渲染文本
   * @param field {String} 字段名称
   */

  computedText(field) {
    if (field === "funds_account_type") {
      const v: any =
        this.detailData["funds_account_type"] &&
        Number(this.detailData["funds_account_type"]);
      switch (v) {
        case 1:
          return this.$t("funds.accountName[0]");
        case 2:
          return this.$t("funds.accountName[1]");
        default:
          return "";
      }
    } else if (field === "funds_change_type") {
      const t: any =
        this.detailData["funds_change_type"] &&
        Number(this.detailData["funds_change_type"]);
      switch (t) {
        case 1:
          return this.$t("myComponent.typeText[0]");
        case 2:
          return this.$t("myComponent.typeText[1]");
        case 5:
          return this.$t("myComponent.typeText[2]");
        default:
          return "";
      }
    } else if (field === "pay_type") {
      const p: any =
        this.detailData["pay_type"] && Number(this.detailData["pay_type"]);
      switch (p) {
        case 1:
          return this.$t("funds.orderDetail.payText[0]");
        case 2:
          return this.$t("funds.orderDetail.payText[1]");
        case 3:
          return this.$t("funds.orderDetail.payText[2]");
        case 4:
          return this.$t("funds.orderDetail.payText[3]");
        case 5:
          return this.$t("funds.orderDetail.payText[4]");
        default:
          return "";
      }
    } else if (field === "order_status") {
      const o: any =
        this.detailData["order_status"] &&
        Number(this.detailData["order_status"]);
      switch (o) {
        case 0:
          return this.$t("myComponent.statusText[0]");
        case 1:
          return this.$t("myComponent.statusText[1]");
        case 2:
          return this.$t("myComponent.statusText[2]");
        case 3:
          return this.$t("myComponent.statusText[3]");
        case 4:
          return this.$t("myComponent.statusText[4]");
		case 5:
      return this.$t("myComponent.statusText[5]");
        default:
          return "";
      }
    } else if (
      field === "amount" ||
      field === "handling_fee" ||
      field === "received_amount"
    ) {
      if(field === "amount" && this.detailData.funds_type == 2 && this.detailData.is_all == 1){
        return this.detailData[field];
      }else{
        return (
          this.detailData[field] && this.formatMoney(this.detailData[field], 2)
        );
      }

    } else if ( field == 'created_at' || field == 'received_at' ) {
      return this.formatDate(this.detailData[field])
    } else {
      return this.detailData[field];
    }
  }

  /**
   * 格式化金额
   */

  formatMoney(money, len) {
    if (!money && money != 0) return "0.00";
    if (isNaN(+money)) return "0.00";
    len = len || 2;
    const arr = (money + "").split(".");
    const intStr = arr[0] ? arr[0] : 0;
    let floatStr = arr[1] ? arr[1] : 0;
    if (floatStr == 0) {
      floatStr = "0";
      for (let i = 0; i < len - 1; i++) {
        floatStr += "0";
      }
    } else {
      floatStr = (+("0." + floatStr)).toFixed(len).split(".")[1];
    }
    money = (intStr + "." + floatStr).replace(
      /(\d{1,3})(?=(?:\d{3})+\.)/g,
      "$1,"
    );
    return money;
  }
  formatDate = (dateStr) => {
      if (!dateStr) return '--';
      // 将连字符替换为斜杠，iOS 能更好地支持斜杠格式
      const safeDateStr = dateStr.replace(/-/g, '/');
      const date = new Date(safeDateStr);
      
      // 增加日期有效性检查
      if (isNaN(date.getTime())) {
          return '--';
      }

      const yy = date.getFullYear().toString().slice(-2);
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const mi = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');
      return `${yy}/${mm}/${dd} ${hh}:${mi}:${ss}`;
  }

  /**
   * 获取订单详情
   */
  getOrderDetailData() {
    (this as any).$apis
      .getFundsRecordDetail({ record_id: this.$route.query.id })
      .then(res => {
        this.requestFail = false;
        this.detailData = res;
        if (res.voucher) {
          this.voucherList = res.voucher.split(",");
          if (this.voucherList && this.voucherList.length > 6) {
            this.voucherList = this.voucherList.slice(0, 6);
          }
        }
      })
      .catch(() => {
        this.requestFail = true;
      });
  }

  previewImg(index) {
    this.previewInstance = ImagePreview({
      images: this.voucherList,
      startPosition: index
    });
  }

  getcancel(){
	  this.showCancel = true
  }

  handConfirm(){
	  if((this as any).detailData["funds_change_type"] == 2){
		(this as any).$apis.getFundsCancel({ record_id: this.$route.query.id }).then(res =>{
		   (this as any).getOrderDetailData();
    })
	  }else{
		(this as any).$apis.getRechargeCancel({ record_id: this.$route.query.id }).then(res =>{
		   (this as any).getOrderDetailData();
    })
	  }


  }

  computedStatusClass(field) {
    if (field !== 'order_status') return '';
    
    const statusMap = {
      0: 'wait-color',
      1: 'success-color', 
      2: 'fail-color',
      3: 'auto-color',
      4: 'back-color',
      5: 'cancel-color'
    };

    const status = Number(this.detailData['order_status']);
    return statusMap[status] || '';
  }

  beforeDestroy() {
    this.previewInstance && this.previewInstance.close();
  }
}
